// extracted by mini-css-extract-plugin
export default {"errorWrapper":"GoogleMapComponent_errorWrapper__bU41B","errorHeader":"GoogleMapComponent_errorHeader__d3v0s"};